class APIModel {

    //LIVE 

    static URL = "https://api.securelienrelease.com/";
    static HOST = "https://api.securelienrelease.com/api/";
    static F_URL = "http://localhost:3000/webapp/#/";
    static F_URL = "http://localhost:3000/#";

    //LIVE Test Domain

    // static URL = "https://securelien.anasw.com/";
    // static HOST = "https://securelien.anasw.com/api/";
    // static F_URL = "https://securelien-web.anasw.com/#/";

    //local

    //static URL = "http://127.0.0.1:8000/";
    //static HOST = "http://127.0.0.1:8000/api/";
    //static F_URL = "http://localhost:3000/#";

    // CORS In package.json after home veriable
    // "proxy" : "http://localhost:8000/",
}
export default APIModel;